import { render, staticRenderFns } from "./MultiText.vue?vue&type=template&id=3eac2015&scoped=true"
import script from "./MultiText.vue?vue&type=script&lang=js"
export * from "./MultiText.vue?vue&type=script&lang=js"
import style0 from "./MultiText.vue?vue&type=style&index=0&id=3eac2015&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eac2015",
  null
  
)

export default component.exports